/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable, DataTableSelectEvent } from "primereact/datatable";
import { Panel } from "primereact/panel"
import { Toast } from "primereact/toast"
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useParams } from "react-router-dom";
import { StyleService } from "../../service/StyleService";
import StyleRule from "../../models/StyleRule";
import React from "react";
import { Dialog } from "primereact/dialog";
import { RadioButton, RadioButtonChangeEvent } from "primereact/radiobutton";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { Divider } from "primereact/divider";
import { useMsal } from "@azure/msal-react";
import SeqMap from "../../models/SeqMap";
import { ProgressSpinner } from 'primereact/progressspinner';
import SetupPrompt from "../../models/SetupPrompt";

const StyleRules = () => {
    const emptyStyleRule: StyleRule = {
        styleCd: '',
        seq: 0,
        ruleType: 0,
        condPrompt: 0,
        condValue: '',
        promptA: 0,
        promptB: 0,
        valueB: '',
        timestamp: '',
        chgUser: '',
        warnOnly: 0,
        allowConc: 0
    };

    // Common properties
    const [selectedOption, setSelectedOption] = useState<number | null>(null);
    const [checkedWarn, setCheckedWarn] = useState<boolean>(false);
    const [checkedColorOnColor, setCheckedColorOnColor]  = useState<boolean>(false);

    // Rule Type 1
    const [selectedCondPrompt1, setSelectedCondPrompt1] = useState<SetupPrompt | null>(null);
    const [selectedCondValue1, setSelectedCondValue1] = useState<string | null>(null);
    const [selectedPromptA1, setSelectedPromptA1] = useState<SetupPrompt | null>(null);
    const [selectedPromptB1, setSelectedPromptB1] = useState<SetupPrompt | null>(null);
    const [validationError1, setValidationError1] = useState<boolean>(false);

    // Rule Type 2
    const [selectedCondPrompt2, setSelectedCondPrompt2] = useState<SetupPrompt | null>(null);
    const [selectedCondValue2, setSelectedCondValue2] = useState<string | null>(null);
    const [selectedPromptA2, setSelectedPromptA2] = useState<SetupPrompt | null>(null);
    const [selectedPromptB2, setSelectedPromptB2] = useState<SetupPrompt | null>(null);
    const [validationError2, setValidationError2] = useState<boolean>(false);
    
    // Rule Type 3
    const [selectedCondPrompt3, setSelectedCondPrompt3] = useState<SetupPrompt | null>(null);
    const [selectedCondValue3, setSelectedCondValue3] = useState<string | null>(null);
    const [selectedValueB3, setSelectedValueB3] = useState<string | null>(null);
    const [selectedPromptB3, setSelectedPromptB3] = useState<SetupPrompt | null>(null);
    const [validationError3, setValidationError3] = useState<boolean>(false);

    // Rule Type 4
    const [selectedPromptA4, setSelectedPromptA4] = useState<SetupPrompt | null>(null);
    const [selectedPromptB4, setSelectedPromptB4] = useState<SetupPrompt | null>(null);
    const [validationError4, setValidationError4] = useState<boolean>(false);

    // Rule Type 5
    const [selectedPromptA5, setSelectedPromptA5] = useState<SetupPrompt | null>(null);
    const [selectedPromptB5, setSelectedPromptB5] = useState<SetupPrompt | null>(null);
    const [validationError5, setValidationError5] = useState<boolean>(false);

    // Rule Type 6
    const [selectedCondPrompt6, setSelectedCondPrompt6] = useState<SetupPrompt | null>(null);
    const [selectedCondValue6, setSelectedCondValue6] = useState<string | null>(null);
    const [selectedValueB6, setSelectedValueB6] = useState<string | null>(null);
    const [selectedPromptB6, setSelectedPromptB6] = useState<SetupPrompt | null>(null);
    const [validationError6, setValidationError6] = useState<boolean>(false);


    // Disable handlers for rule types
    const [isDisabledOption1, setIsDisabledOption1] = useState<boolean>(true);
    const [isDisabledOption2, setIsDisabledOption2] = useState<boolean>(true);
    const [isDisabledOption3, setIsDisabledOption3] = useState<boolean>(true);
    const [isDisabledOption4, setIsDisabledOption4] = useState<boolean>(true);
    const [isDisabledOption5, setIsDisabledOption5] = useState<boolean>(true);
    const [isDisabledOption6, setIsDisabledOption6] = useState<boolean>(true);


    const [loadingRules, setloadingRules] = useState<boolean>(false);
    const [loadingCurrentRules, setLoadingCurrentRules] = useState<boolean>(true);
    const [loadingSetupPrompts, setLoadingSetupPrompts] = useState<boolean>(true);
    const [ruleDialogVisible, setRuleDialogVisible] = useState<boolean>(false);
    const [promptsDialogVisible, setPromptsDialogVisible] = useState<boolean>(false);
    const [deleteStyleRuleDialog, setDeleteStyleRuleDialog] = useState<boolean>(false);
    

    const [styleRules, setStyleRules] = useState<StyleRule[]>([]);
    const [styleRule, setStyleRule] = useState<StyleRule>(emptyStyleRule);
    const [setupPrompts, setSetupPrompts] = useState<SetupPrompt[]>([]);
    const [condValues, setCondValues] = useState<string[]>([]);
    const [valueBs, setvalueBs] = useState<string[]>([]);


    const form = useForm();
    const isNew = useRef(true);
    const dt = useRef<any>(null);
    const toast = useRef<any>(null);
    const { styleCode } = useParams();
    const { accounts } = useMsal();

    useEffect(() => {
        if (!styleCode) { return; }

        setloadingRules(true);
        StyleService.getStyleRules(styleCode).then((data: StyleRule[]) => {
            setStyleRules(data);
            setLoadingCurrentRules(false);
            setloadingRules(false);
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Error in DB', life: 3000 });
            setLoadingSetupPrompts(false);
            setLoadingCurrentRules(false);
            setloadingRules(false);
            setStyleRules([]);
        });

        StyleService.getSetupPrompts(styleCode).then((data: SetupPrompt[]) => {
            if (!data) {
                setLoadingSetupPrompts(false);
                return;
            }
            setSetupPrompts(data);
            setLoadingSetupPrompts(false);
            setloadingRules(false);
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Error in DB', life: 3000 });
            setLoadingSetupPrompts(false);
            setloadingRules(false);
            setStyleRules([]);
        });
    }, [styleCode]);
    
    useEffect(() => {
        [selectedCondPrompt1, selectedCondPrompt2, selectedCondPrompt3, selectedCondPrompt6].forEach((prompt, index) => {
            if (prompt?.seq !== undefined) {
                populateCondValue(prompt.seq);
            }
        });
    }, [selectedCondPrompt1, selectedCondPrompt2, selectedCondPrompt3, selectedCondPrompt6]);

    useEffect(() => {
        [selectedPromptB3, selectedPromptB6].forEach((prompt, index) => {
            if (prompt?.seq !== undefined) {
                populateValueB(prompt.seq);
            }
        });
    }, [selectedPromptB3, selectedPromptB6]);

    const populateCondValue = (seq: number | null | undefined) => {
        if (!styleCode) { return; }
        if (!seq) { return; }
        StyleService.getPromptColors(styleCode, seq, "regular").then((data: string[]) => {
            setCondValues(data);
        });
    };

    const populateValueB = (seq: number | null | undefined) => {
        if (!styleCode) { return; }
        if (!seq) { return; }
        StyleService.getPromptColors(styleCode, seq, "regular").then((data: string[]) => {
            setvalueBs(data);
        });
    };

    // Templates for datatable
    const rowClass = (data: StyleRule) => {
        return {
            'bg-yellow-200': data.warnOnly === 1
        };
    };
    const setupPromptSeqTemplate = (rowData: SetupPrompt) => rowData.seq;
    const setupPromptTemplate = (rowData: SetupPrompt) => rowData.prompt;

    const seqTemplate = (rowData: StyleRule) => rowData.seq;
    const ruleTypeTemplate = (rowData: StyleRule) => rowData.ruleType;
    const condPromptTemplate = (rowData: StyleRule) => rowData.condPrompt;
    const condValueTemplate = (rowData: StyleRule) => rowData.condValue;
    const promptATemplate = (rowData: StyleRule) => rowData.promptA;
    const promptBTemplate = (rowData: StyleRule) => rowData.promptB;
    const valueBTemplate = (rowData: StyleRule) => rowData.valueB;
    const warnOnlyTemplate = (rowData: StyleRule) => {
        if (rowData.warnOnly) {
            return (
                <React.Fragment>
                    <i className="pi pi-check text-green-500"></i>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <i className="pi pi-times text-red-500"></i>
                </React.Fragment>
            );
        }
    }

    const allowConcTemplate = (rowData: StyleRule) => {
        if (rowData.allowConc) {
            return (
                <React.Fragment>
                    <i className="pi pi-check text-green-500"></i>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <i className="pi pi-times text-red-500"></i>
                </React.Fragment>
            );
        }
    }

    const ruleDescriptionTemplate = (rowData: StyleRule) => {
        const condPrompt = setupPrompts.find(setupPrompt => setupPrompt.seq === rowData.condPrompt)?.prompt;
        const promptA = setupPrompts.find(setupPrompt => setupPrompt.seq === rowData.promptA)?.prompt;
        const promptB = setupPrompts.find(setupPrompt => setupPrompt.seq === rowData.promptB)?.prompt;
        const condValue = rowData.condValue;
        const valueB = rowData.valueB;
    
        switch (rowData.ruleType) {
            case 1:
                return <span>If <strong>{condPrompt}</strong> is equal to <strong>{condValue}</strong>, then <strong>{promptA}</strong> must be the same as <strong>{promptB}</strong>.</span>;
            case 2:
                return <span>If <strong>{condPrompt}</strong> is equal to <strong>{condValue}</strong>, then <strong>{promptA}</strong> cannot be the same as <strong>{promptB}</strong>.</span>;
            case 3:
                return <span>If <strong>{condPrompt}</strong> is equal to <strong>{condValue}</strong>, then <strong>{promptB}</strong> must contain the value <strong>{valueB}</strong>.</span>;
            case 4:
                return <span><strong>{promptB}</strong> cannot be the same as <strong>{promptA}</strong>.</span>;
            case 5:
                return <span><strong>{promptA}</strong> must be the same as <strong>{promptB}</strong>.</span>;
            case 6:
                return <span>If <strong>{condPrompt}</strong> is equal to <strong>{condValue}</strong>, then <strong>{promptB}</strong> cannot contain the value <strong>{valueB}</strong>.</span>;
            default:
                return <span>No rule description available.</span>;
        }
    }

    const save = (value: StyleRule) => {
        let _listValues = [...styleRules];
        if (isNew.current) {
            StyleService.addStyleRule(value).then((data) => {
                if (data) {
                    _listValues.push(data);
                    setStyleRules(_listValues);
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Style Rule Created', life: 3000 });
                    setStyleRule(emptyStyleRule);
                    hideRuleStyleRuleDialog()
                    form.reset();
                } else {
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Create Style Rule', life: 3000 });
                }
            }).catch(() => {
                toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Create Style Rule', life: 3000 });
            });
        } else {
            StyleService.updateStyleRule(value).then((data) => {
                if (data) {
                    let index = _listValues.findIndex(v => v.styleCd === value.styleCd && v.seq === value.seq);
                    _listValues[index] = value;
                    setStyleRules(_listValues);
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Style Rule Updated', life: 3000 });
                    setStyleRule(emptyStyleRule);
                    hideRuleStyleRuleDialog();
                    isNew.current = true;
                } else {
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Update Style Rule', life: 3000 });
                }
            }).catch(() => {
                toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Update Style Rule', life: 3000 });
            });
        }
    }

    const deleteStyleRule = () => {
        if (!styleCode) {return;}
        StyleService.deleteStyleRule(styleRule.seq, styleCode).then((data) => {
            if (data) {
                let _styleRules = styleRules.filter(val => val.seq !== styleRule.seq);
                setStyleRules(_styleRules);
                setDeleteStyleRuleDialog(false);
                setStyleRule(emptyStyleRule);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Style Rule Deleted', life: 3000 });
            } else {
                toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Delete Style Rule', life: 3000 });
            }
        });
    }

    const cleanOptions = () => {
        setSelectedCondValue1(null);
        setSelectedCondValue2(null);
        setSelectedCondValue3(null);
        setSelectedCondValue6(null);

        setSelectedCondPrompt1(null);
        setSelectedCondPrompt2(null);
        setSelectedCondPrompt3(null);
        setSelectedCondPrompt6(null);

        setSelectedPromptA1(null);
        setSelectedPromptA2(null);
        setSelectedPromptA4(null);
        setSelectedPromptA5(null);

        setSelectedPromptB1(null);
        setSelectedPromptB2(null);
        setSelectedPromptB4(null);
        setSelectedPromptB5(null);

        setSelectedValueB3(null);
        setSelectedValueB6(null);

        setCheckedWarn(false);
        setCheckedColorOnColor(false);

        setSelectedOption(null);
    };

    const confirmDeleteStyleRule = (styleRule: StyleRule) => {
        setStyleRule(styleRule);
        setDeleteStyleRuleDialog(true);
    }

    const hideDeleteStyleRuleDialog = () => {        
        setDeleteStyleRuleDialog(false);
    };

    const hideRuleStyleRuleDialog = () => { 
        setRuleDialogVisible(false);
        cleanOptions();
        disableDropdowns("0");
        isNew.current = true;
    };

    const deleteStyleRuleDialogFooter = (
        <>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteStyleRuleDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteStyleRule} />
        </>
    );

    const onSubmit = (data: any) => {
        if (!styleCode) { return; }

        var ruleType = selectedOption;
        let _styleRule: StyleRule = { ...styleRule };
        _styleRule.styleCd = styleCode;

        switch (ruleType) {
            case 1:
                setValidationError1(true);
                if (!selectedCondPrompt1?.seq || !selectedPromptA1?.seq || !selectedPromptB1?.seq || !selectedCondValue1) {
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Please fill in all the required fields.', life: 3000 });
                    return;
                }

                _styleRule.ruleType = ruleType;
                _styleRule.condPrompt = selectedCondPrompt1.seq;
                _styleRule.condValue = selectedCondValue1;
                _styleRule.promptA = selectedPromptA1.seq;
                _styleRule.promptB = selectedPromptB1.seq;
                _styleRule.warnOnly = checkedWarn === true? 1 : 0;
                _styleRule.allowConc = checkedColorOnColor === true? 1 : 0;
                _styleRule.valueB = '';
                break;
            case 2:
                setValidationError2(true);
                if (!selectedCondPrompt2?.seq || !selectedPromptA2?.seq || !selectedPromptB2?.seq || !selectedCondValue2) {
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Please fill in all the required fields.', life: 3000 });
                    return;
                }
                _styleRule.ruleType = ruleType;
                _styleRule.condPrompt = selectedCondPrompt2.seq;
                _styleRule.condValue = selectedCondValue2;
                _styleRule.promptA = selectedPromptA2.seq;
                _styleRule.promptB = selectedPromptB2.seq;
                _styleRule.warnOnly = checkedWarn === true? 1 : 0;
                _styleRule.allowConc = checkedColorOnColor === true? 1 : 0;
                _styleRule.valueB = '';
                break;
            case 3:
                setValidationError3(true);
                if (!selectedCondPrompt3?.seq || !selectedPromptB3?.seq || !selectedCondValue3 || !selectedValueB3) {
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Please fill in all the required fields.', life: 3000 });
                    return;
                }
                _styleRule.ruleType = ruleType;
                _styleRule.condPrompt = selectedCondPrompt3.seq;
                _styleRule.condValue = selectedCondValue3;
                _styleRule.promptA = 0;
                _styleRule.promptB = selectedPromptB3.seq;
                _styleRule.valueB = selectedValueB3;
                _styleRule.warnOnly = checkedWarn === true? 1 : 0;
                _styleRule.allowConc = checkedColorOnColor === true? 1 : 0;
                break;
            case 4:
                setValidationError4(true);
                if (!selectedPromptA4?.seq || !selectedPromptB4?.seq) {
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Please fill in all the required fields.', life: 3000 });
                    return;
                }
                _styleRule.ruleType = ruleType;
                _styleRule.condPrompt = 0;
                _styleRule.condValue = '';
                _styleRule.promptA = selectedPromptA4.seq;
                _styleRule.promptB = selectedPromptB4.seq;
                _styleRule.warnOnly = checkedWarn === true? 1 : 0;
                _styleRule.allowConc = checkedColorOnColor === true? 1 : 0;
                _styleRule.valueB = '';
                break;
            case 5:
                setValidationError5(true);
                if (!selectedPromptA5?.seq || !selectedPromptB5?.seq) {
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Please fill in all the required fields.', life: 3000 });
                    return;
                }
                _styleRule.ruleType = ruleType;
                _styleRule.condPrompt = 0;
                _styleRule.condValue = '';
                _styleRule.promptA = selectedPromptA5.seq;
                _styleRule.promptB = selectedPromptB5.seq;
                _styleRule.warnOnly = checkedWarn === true? 1 : 0;
                _styleRule.allowConc = checkedColorOnColor === true? 1 : 0;
                _styleRule.valueB = '';
                break;
            case 6:
                setValidationError6(true);
                if (!selectedCondPrompt6?.seq || !selectedPromptB6?.seq || !selectedCondValue6 || !selectedValueB6) {
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Please fill in all the required fields.', life: 3000 });
                    return;
                }
                _styleRule.ruleType = ruleType;
                _styleRule.condPrompt = selectedCondPrompt6.seq;
                _styleRule.condValue = selectedCondValue6;
                _styleRule.promptA = 0;
                _styleRule.promptB = selectedPromptB6.seq;
                _styleRule.valueB = selectedValueB6;
                _styleRule.warnOnly = checkedWarn === true? 1 : 0;
                _styleRule.allowConc = checkedColorOnColor === true? 1 : 0;
                break;
            default:
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Please select a rule type.', life: 3000 });
                break;
        }

        if (isNew.current){
            const maxSeq = styleRules.length > 0 ? Math.max(...styleRules.map(rule => rule.seq)) : -1;
            const nextSeq = maxSeq + 1;
            _styleRule.seq = nextSeq;
        }
        
        if (accounts[0]){
            _styleRule.timestamp = new Date().toISOString();
            _styleRule.chgUser = accounts[0].username.split('@')[0];
        }

        save(_styleRule);
    };

    const rowEditorStyleRulesTemplate = (rowData: StyleRule, props: any) => {
        return (
            <>
                <Link className="pi pi-fw pi-trash rowDelete" title="Delete" onClick={() => confirmDeleteStyleRule(rowData)} to={''}></Link>
            </>
        );
    }
      

    const disableDropdowns = (selectedOption: string) => {      
        // Object containing all setIsDisabledOption functions
        const setters = {
          1: setIsDisabledOption1,
          2: setIsDisabledOption2,
          3: setIsDisabledOption3,
          4: setIsDisabledOption4,
          5: setIsDisabledOption5,
          6: setIsDisabledOption6,
        };

        if (selectedOption === "0"){
            // Disable all options
            Object.entries(setters).forEach(([option, setDisabled]) => {
                setDisabled(true);
              });
        } else {
            // Disable all options and enable the selected one
            Object.entries(setters).forEach(([option, setDisabled]) => {
                setDisabled(option !== selectedOption);
            });
        }

        const settersValidations = {
            1: setValidationError1,
            2: setValidationError2,
            3: setValidationError3,
            4: setValidationError4,
            5: setValidationError5,
            6: setValidationError6
        };

        Object.entries(settersValidations).forEach(([option, setDisabled]) => {
            setDisabled(false);
        });
    };

    

    const updateSequences = (e: any) => {
        if (!styleCode) { return; }

        const fromIndex = e.dragIndex;
        const toIndex = e.dropIndex;
    
        // Create a copy of the styleRules array
        const _styleRules: StyleRule[] = [...styleRules];
        
        const itemMoved = _styleRules[fromIndex];
        if (!itemMoved) {
            return;
        }
    
        // Remove the item from its original position and insert it at the new position
        _styleRules.splice(fromIndex, 1);
        _styleRules.splice(toIndex, 0, itemMoved);
    
        
        // Create a new list to map old sequence numbers to new sequence numbers
        const seqMapping: SeqMap[] = _styleRules.map((rule, index) => {
            return { oldSeq: rule.seq, newSeq: index };
        });

        setloadingRules(true);
        StyleService.reorderRules(seqMapping, styleCode).then((data: StyleRule[]) => {        
            setStyleRules(data);
            setloadingRules(false);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Style Rule Updated', life: 3000 });
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Update Style Rule', life: 3000 });
            setloadingRules(false);
        });
    }

    const onRowSelect = (event: DataTableSelectEvent) => {
        isNew.current = false;

        const styleRule = event.data as StyleRule;
        setSelectedOption(styleRule.ruleType);
        let _styleRule: StyleRule = { ...styleRule };
        _styleRule.seq = styleRule.seq;
        _styleRule.timestamp = styleRule.timestamp
        _styleRule.chgUser = styleRule.chgUser;

        setStyleRule(_styleRule);

        switch (styleRule.ruleType) {
            case 1:
                setSelectedCondPrompt1(setupPrompts.find(setupPrompt => setupPrompt.seq === styleRule.condPrompt) ?? null);
                setSelectedPromptA1(setupPrompts.find(setupPrompt => setupPrompt.seq === styleRule.promptA) ?? null);
                setSelectedPromptB1(setupPrompts.find(setupPrompt => setupPrompt.seq === styleRule.promptB) ?? null);
                setSelectedCondValue1(styleRule.condValue);
                setCheckedWarn(styleRule.warnOnly === 1 ? true : false);
                setCheckedColorOnColor(styleRule.allowConc === 1 ? true : false);
                setIsDisabledOption1(false);
                break;
            case 2:
                setSelectedCondPrompt2(setupPrompts.find(setupPrompt => setupPrompt.seq === styleRule.condPrompt) ?? null);
                setSelectedPromptA2(setupPrompts.find(setupPrompt => setupPrompt.seq === styleRule.promptA) ?? null);
                setSelectedPromptB2(setupPrompts.find(setupPrompt => setupPrompt.seq === styleRule.promptB) ?? null);
                setSelectedCondValue2(styleRule.condValue);
                setCheckedWarn(styleRule.warnOnly === 1 ? true : false);
                setCheckedColorOnColor(styleRule.allowConc === 1 ? true : false);
                setIsDisabledOption2(false);
                break;
            case 3:
                setSelectedCondPrompt3(setupPrompts.find(setupPrompt => setupPrompt.seq === styleRule.condPrompt) ?? null);
                setSelectedPromptB3(setupPrompts.find(setupPrompt => setupPrompt.seq === styleRule.promptB) ?? null);
                setSelectedCondValue3(styleRule.condValue);
                setSelectedValueB3(styleRule.valueB);
                setCheckedWarn(styleRule.warnOnly === 1 ? true : false);
                setCheckedColorOnColor(styleRule.allowConc === 1 ? true : false);
                setIsDisabledOption3(false);
                break;
            case 4:
                setSelectedPromptA4(setupPrompts.find(setupPrompt => setupPrompt.seq === styleRule.promptA) ?? null);
                setSelectedPromptB4(setupPrompts.find(setupPrompt => setupPrompt.seq === styleRule.promptB) ?? null);
                setCheckedWarn(styleRule.warnOnly === 1 ? true : false);
                setCheckedColorOnColor(styleRule.allowConc === 1 ? true : false);
                setIsDisabledOption4(false);
                break;
            case 5:
                setSelectedPromptA5(setupPrompts.find(setupPrompt => setupPrompt.seq === styleRule.promptA) ?? null);
                setSelectedPromptB5(setupPrompts.find(setupPrompt => setupPrompt.seq === styleRule.promptB) ?? null);
                setCheckedWarn(styleRule.warnOnly === 1 ? true : false);
                setCheckedColorOnColor(styleRule.allowConc === 1 ? true : false);
                setIsDisabledOption5(false);
                break;
            case 6:
                setSelectedCondPrompt6(setupPrompts.find(setupPrompt => setupPrompt.seq === styleRule.condPrompt) ?? null);
                setSelectedPromptB6(setupPrompts.find(setupPrompt => setupPrompt.seq === styleRule.promptB) ?? null);
                setSelectedCondValue6(styleRule.condValue);
                setSelectedValueB6(styleRule.valueB);
                setCheckedWarn(styleRule.warnOnly === 1 ? true : false);
                setCheckedColorOnColor(styleRule.allowConc === 1 ? true : false);
                setIsDisabledOption6(false);
                break;
            default:
                break;
        }

        disableDropdowns(styleRule.ruleType.toString());
        setRuleDialogVisible(true);
    };
    

    return (
        <div className="grid-nogutter">
            <div className="col-12">
                <Toast ref={toast} />
                <Panel className="-ml-2 mt-2" title="Current Rules" header="Current Rules">
                    <Button label="Add New Rule" icon="pi pi-external-link" size="small" severity="success" outlined onClick={() => setRuleDialogVisible(true)} />
                    <Button label="Show Prompts" className="ml-2" icon="pi pi-info" size="small" severity="info" onClick={() => setPromptsDialogVisible(true)} />
                    {loadingRules && (
                        <ProgressSpinner style={{width: '30px', height: '30px'}} className="ml-2" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                    )}
                    <Dialog header="Add/Edit Rule" visible={ruleDialogVisible} closeOnEscape closable dismissableMask style={{ width: '80vw' }} onHide={() => hideRuleStyleRuleDialog()}>
                        <ul className="instructions">
                            <li>Select rule by clicking on button.</li>
                            <li>Select values for all drop downs.</li>
                            <li>Click on Apply to save values in Rule table, or on Cancel button to exit without saving.</li>
                        </ul>
                        <form onSubmit={form.handleSubmit(onSubmit)} className="p-fluid" autoComplete="off">
                            <div className="mt-4 flex justify-content-center">
                                <div className="flex flex-column gap-3">
                                    <div className="flex align-items-center">
                                        <RadioButton inputId="option1" name="option2" value={1} onChange={(e: RadioButtonChangeEvent) => {setSelectedOption(e.value); disableDropdowns(e.value.toString())}} checked={selectedOption === 1} />
                                        <span className="ml-2 mr-2"> If </span>
                                        <Dropdown value={selectedCondPrompt1} onChange={(e: DropdownChangeEvent) => setSelectedCondPrompt1(e.value)} options={setupPrompts} optionLabel="prompt" 
                                            placeholder="Select..." className={`w-full md:w-14rem ${validationError1 && !selectedCondPrompt1 ? 'p-invalid border-left-10': ''}`} disabled={isDisabledOption1} />
                                        <span className="ml-2 mr-2"> is equal to </span>
                                        <Dropdown value={selectedCondValue1} onChange={(e: DropdownChangeEvent) => setSelectedCondValue1(e.value)} options={condValues} 
                                            placeholder="Select..." className={`w-full md:w-14rem ${validationError1 && !selectedCondValue1 ? 'p-invalid border-left-10': ''}`} disabled={isDisabledOption1} />
                                        <span className="ml-2 mr-2"> , then </span>
                                        <Dropdown value={selectedPromptA1} onChange={(e: DropdownChangeEvent) => setSelectedPromptA1(e.value)} options={setupPrompts} optionLabel="prompt" 
                                            placeholder="Select..." className={`w-full md:w-14rem ${validationError1 && !selectedPromptA1 ? 'p-invalid border-left-10': ''}`} disabled={isDisabledOption1} />
                                        <span className="ml-2 mr-2"> must be the same as </span>
                                        <Dropdown value={selectedPromptB1} onChange={(e: DropdownChangeEvent) => setSelectedPromptB1(e.value)} options={setupPrompts} optionLabel="prompt" 
                                            placeholder="Select..." className={`w-full md:w-14rem ${validationError1 && !selectedPromptB1 ? 'p-invalid border-left-10': ''}`} disabled={isDisabledOption1} />
                                    </div>
                                    <div className="flex align-items-center">
                                        <RadioButton inputId="option2" name="option2" value={2} onChange={(e: RadioButtonChangeEvent) => {setSelectedOption(e.value); disableDropdowns(e.value.toString())}} checked={selectedOption === 2} />
                                        <span className="ml-2 mr-2"> If </span>
                                        <Dropdown value={selectedCondPrompt2} onChange={(e: DropdownChangeEvent) => setSelectedCondPrompt2(e.value)} options={setupPrompts} optionLabel="prompt" 
                                            placeholder="Select..." className={`w-full md:w-14rem ${validationError2 && !selectedCondPrompt2 ? 'p-invalid border-left-10': ''}`} disabled={isDisabledOption2} />
                                        <span className="ml-2 mr-2"> is equal to </span>
                                        <Dropdown value={selectedCondValue2} onChange={(e: DropdownChangeEvent) => setSelectedCondValue2(e.value)} options={condValues}
                                            placeholder="Select..." className={`w-full md:w-14rem ${validationError2 && !selectedCondValue2 ? 'p-invalid border-left-10': ''}`} disabled={isDisabledOption2} />
                                        <span className="ml-2 mr-2"> , then </span>
                                        <Dropdown value={selectedPromptA2} onChange={(e: DropdownChangeEvent) => setSelectedPromptA2(e.value)} options={setupPrompts} optionLabel="prompt" 
                                            placeholder="Select..." className={`w-full md:w-14rem ${validationError2 && !selectedPromptA2 ? 'p-invalid border-left-10': ''}`} disabled={isDisabledOption2} />
                                        <span className="ml-2 mr-2"> cannot be the same as </span>
                                        <Dropdown value={selectedPromptB2} onChange={(e: DropdownChangeEvent) => setSelectedPromptB2(e.value)} options={setupPrompts} optionLabel="prompt" 
                                            placeholder="Select..." className={`w-full md:w-14rem ${validationError2 && !selectedPromptB2 ? 'p-invalid border-left-10': ''}`} disabled={isDisabledOption2} />
                                    </div>
                                    <div className="flex align-items-center">
                                        <RadioButton inputId="option3" name="option3" value={3} onChange={(e: RadioButtonChangeEvent) => {setSelectedOption(e.value); disableDropdowns(e.value.toString())}} checked={selectedOption === 3} />
                                        <span className="ml-2 mr-2"> If </span>
                                        <Dropdown value={selectedCondPrompt3} onChange={(e: DropdownChangeEvent) => setSelectedCondPrompt3(e.value)} options={setupPrompts} optionLabel="prompt" 
                                            placeholder="Select..." className={`w-full md:w-14rem ${validationError3 && !selectedCondPrompt3 ? 'p-invalid border-left-10': ''}`} disabled={isDisabledOption3} />
                                        <span className="ml-2 mr-2"> is equal to </span>
                                        <Dropdown value={selectedCondValue3} onChange={(e: DropdownChangeEvent) => setSelectedCondValue3(e.value)} options={condValues}
                                            placeholder="Select..." className={`w-full md:w-14rem ${validationError3 && !selectedCondValue3 ? 'p-invalid border-left-10': ''}`} disabled={isDisabledOption3} />
                                        <span className="ml-2 mr-2"> , then </span>
                                        <Dropdown value={selectedPromptB3} onChange={(e: DropdownChangeEvent) => setSelectedPromptB3(e.value)} options={setupPrompts} optionLabel="prompt" 
                                            placeholder="Select..." className={`w-full md:w-14rem ${validationError3 && !selectedPromptB3 ? 'p-invalid border-left-10': ''}`} disabled={isDisabledOption3} />
                                        <span className="ml-2 mr-2"> must contain the value </span>
                                        <Dropdown value={selectedValueB3} onChange={(e: DropdownChangeEvent) => setSelectedValueB3(e.value)} options={valueBs} 
                                            placeholder="Select..." className={`w-full md:w-14rem ${validationError3 && !selectedValueB3 ? 'p-invalid border-left-10': ''}`} disabled={isDisabledOption3} />
                                    </div>
                                    <div className="flex align-items-center">
                                        <RadioButton inputId="option4" name="option4" value={4} onChange={(e: RadioButtonChangeEvent) => {setSelectedOption(e.value); disableDropdowns(e.value.toString())}} checked={selectedOption === 4} />
                                        <span className="ml-2 mr-2">&nbsp;&nbsp;</span>
                                        <Dropdown value={selectedPromptB4} onChange={(e: DropdownChangeEvent) => setSelectedPromptB4(e.value)} options={setupPrompts} optionLabel="prompt" 
                                            placeholder="Select..." className={`w-full md:w-14rem ${validationError4 && !selectedPromptB4 ? 'p-invalid border-left-10': ''}`} disabled={isDisabledOption4} />
                                        <span className="ml-2 mr-2"> cannot be the same as </span>
                                        <Dropdown value={selectedPromptA4} onChange={(e: DropdownChangeEvent) => setSelectedPromptA4(e.value)} options={setupPrompts} optionLabel="prompt" 
                                            placeholder="Select..." className={`w-full md:w-14rem ${validationError4 && !selectedPromptA4 ? 'p-invalid border-left-10': ''}`} disabled={isDisabledOption4} />
                                    </div>
                                    <div className="flex align-items-center">
                                        <RadioButton inputId="option5" name="option5" value={5} onChange={(e: RadioButtonChangeEvent) => {setSelectedOption(e.value); disableDropdowns(e.value.toString())}} checked={selectedOption === 5} />
                                        <span className="ml-2 mr-2">&nbsp;&nbsp;</span>
                                        <Dropdown value={selectedPromptA5} onChange={(e: DropdownChangeEvent) => setSelectedPromptA5(e.value)} options={setupPrompts} optionLabel="prompt" 
                                            placeholder="Select..." className={`w-full md:w-14rem ${validationError5 && !selectedPromptA5 ? 'p-invalid border-left-10': ''}`} disabled={isDisabledOption5} />
                                        <span className="ml-2 mr-2"> must be the same as </span>
                                        <Dropdown value={selectedPromptB5} onChange={(e: DropdownChangeEvent) => setSelectedPromptB5(e.value)} options={setupPrompts} optionLabel="prompt" 
                                            placeholder="Select..." className={`w-full md:w-14rem ${validationError5 && !selectedPromptB5 ? 'p-invalid border-left-10': ''}`} disabled={isDisabledOption5} />                                    
                                    </div>
                                    <div className="flex align-items-center">
                                        <RadioButton inputId="option6" name="option6" value={6} onChange={(e: RadioButtonChangeEvent) => {setSelectedOption(e.value); disableDropdowns(e.value.toString())}} checked={selectedOption === 6} />
                                        <span className="ml-2 mr-2"> If </span>
                                        <Dropdown value={selectedCondPrompt6} onChange={(e: DropdownChangeEvent) => setSelectedCondPrompt6(e.value)} options={setupPrompts} optionLabel="prompt" 
                                            placeholder="Select..." className={`w-full md:w-14rem ${validationError6 && !selectedCondPrompt6 ? 'p-invalid border-left-10': ''}`} disabled={isDisabledOption6} />
                                        <span className="ml-2 mr-2"> is equal to </span>
                                        <Dropdown value={selectedCondValue6} onChange={(e: DropdownChangeEvent) => setSelectedCondValue6(e.value)} options={condValues}
                                            placeholder="Select..." className={`w-full md:w-14rem ${validationError6 && !selectedCondValue6 ? 'p-invalid border-left-10': ''}`} disabled={isDisabledOption6} />
                                        <span className="ml-2 mr-2"> , then </span>
                                        <Dropdown value={selectedPromptB6} onChange={(e: DropdownChangeEvent) => setSelectedPromptB6(e.value)} options={setupPrompts} optionLabel="prompt" 
                                            placeholder="Select..." className={`w-full md:w-14rem ${validationError6 && !selectedPromptB6 ? 'p-invalid border-left-10': ''}`} disabled={isDisabledOption6} />
                                        <span className="ml-2 mr-2"> cannot contain the value </span>
                                        <Dropdown value={selectedValueB6} onChange={(e: DropdownChangeEvent) => setSelectedValueB6(e.value)} options={valueBs}
                                            placeholder="Select..." className={`w-full md:w-14rem ${validationError6 && !selectedValueB6 ? 'p-invalid border-left-10': ''}`} disabled={isDisabledOption6} />
                                    </div>
                                    <Divider />
                                    <div className="flex flex-wrap justify-content-start gap-3">
                                        <div className="flex align-items-center">
                                            <Checkbox onChange={e => setCheckedWarn(e.checked ?? false)} checked={checkedWarn}></Checkbox>
                                            <label htmlFor="warn" className="ml-2">Warn only</label>
                                        </div>
                                        <div className="flex align-items-center">
                                            <Checkbox onChange={e => setCheckedColorOnColor(e.checked ?? false)} checked={checkedColorOnColor}></Checkbox>
                                            <label htmlFor="colorOnColor" className="ml-2">Allow Color on Color</label>
                                        </div>
                                    </div>
                                    <div className="flex flex-wrap justify-content-end gap-3">
                                        <Button icon="pi pi-save" title="Apply" rounded text severity="info" type="submit" />
                                        <Button icon="pi pi-times" title="Cancel" rounded text severity="danger" type="button" onClick={() => hideRuleStyleRuleDialog()} />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </Dialog>
                    <DataTable ref={dt} value={styleRules} size="small" loading={loadingCurrentRules} 
                        reorderableRows onRowReorder={(e) => updateSequences(e)}
                        rowHover={true}
                        rowClassName={rowClass}
                        scrollable scrollHeight="calc(150vh - 25.1rem)"
                        paginator rows={10} rowsPerPageOptions={[5, 10, 25, 50, 75]} 
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} style rules."
                        selectionMode="single" onRowSelect={onRowSelect} 
                        stripedRows 
                        emptyMessage="No current rules found." className="mt-4">
                        <Column rowReorder style={{ width: '3rem' }} />
                        <Column field="seq" header="Seq"  body={seqTemplate} align="center" alignHeader="center" ></Column>
                        <Column field="ruleDesc" header="Rule Description"  body={ruleDescriptionTemplate} align="center" alignHeader="center" ></Column>
                        <Column field="ruleType" header="Rule Type"  body={ruleTypeTemplate} align="center" alignHeader="center" ></Column>
                        <Column field="condPrompt" header="Cond Prompt"  body={condPromptTemplate} align="center" alignHeader="center" ></Column>
                        <Column field="condValue" header="Cond Value"  body={condValueTemplate} align="center" alignHeader="center" ></Column>
                        <Column field="promptA" header="Prompt A"  body={promptATemplate} align="center" alignHeader="center" ></Column>
                        <Column field="promptB" header="Prompt B"  body={promptBTemplate} align="center" alignHeader="center" ></Column>
                        <Column field="valueB" header="Value B"  body={valueBTemplate} align="center" alignHeader="center" ></Column>
                        <Column field="warnOnly" header="Warn Only"  body={warnOnlyTemplate} align="center" alignHeader="center" ></Column>
                        <Column field="allowConc" header="Override"  body={allowConcTemplate} align="center" alignHeader="center" ></Column>
                        <Column rowEditor body={rowEditorStyleRulesTemplate} headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
                    </DataTable>
                </Panel>
                <Dialog header="Setup Prompts" closeOnEscape closable dismissableMask visible={promptsDialogVisible} style={{ width: '80vw' }} onHide={() => setPromptsDialogVisible(false)}>
                    <DataTable value={setupPrompts} dataKey="id" size="small" loading={loadingSetupPrompts}
                        paginator rows={10} rowsPerPageOptions={[5, 10, 25]} 
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} setup prompts."
                        emptyMessage="No current rules found.">
                        <Column field="seq" header="Seq"  body={setupPromptSeqTemplate} align="center" alignHeader="center" ></Column>
                        <Column field="prompt" header="Prompt"  body={setupPromptTemplate} align="center" alignHeader="center" ></Column>
                    </DataTable>
                </Dialog>
                <Dialog visible={deleteStyleRuleDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteStyleRuleDialogFooter} onHide={hideDeleteStyleRuleDialog}>
                    <div className="flex align-items-center justify-content-center">
                        <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                        {styleRule && <span>Are you sure you want to delete style rule <b>{styleRule.seq}</b>?</span>}
                    </div>
                </Dialog>
            </div>
        </div>
    )
}

export default StyleRules;